"use strict";var p=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var a=(o,d,t,i)=>{for(var s=i>1?void 0:i?u(d,t):d,n=o.length-1,r;n>=0;n--)(r=o[n])&&(s=(i?r(d,t,s):r(s))||s);return i&&s&&p(d,t,s),s};import{baseStyles as v,CiscoUElement as g,handleSlotContent as l,html as e,nothing as h}from"@cisco-u/base";import{property as c}from"@cisco-u/base/src/decorators.js";import m from"./purchase-card.css.js";export class PurchaseCard extends g{constructor(){super(...arguments);this.headingType="h3"}static get styles(){return[v,m]}willUpdate(t){["discounted","price"].forEach(s=>{const n=this[s];if(t.has(s)&&typeof n=="number"){const r=n.toString();switch(s){case"discounted":this.discounted=r;break;case"price":this.price=r;break}}})}render(){return e`<div class="purchase-card">
      <div class="body">
        <div class="upper">
          ${this._returnHeading()}
          <div class="description">
            <slot
              name="description"
              @slotchange=${t=>l(t.target)}
            ></slot>
          </div>
          <div class="price-details">
            ${this.discounted&&this.discounted!=="0"?e`<div class="discounted " aria-label="Price">
                  <span>$</span
                  ><span class="discounted-number flex"
                    >${this._showPrice(this.discounted)}
                    <div class="cents">
                      ${this._showCent(this.discounted)}
                    </div></span
                  >
                </div>`:h}
            <div
              class="price"
              aria-label=${this.discounted&&this.discounted!=="0"?h:"Price"}
            >
              ${this.discounted&&this.discounted!=="0"?e`<s>
                    <span>$</span
                    ><span class="price-number flex"
                      >${this._showPrice(this.price)}
                      <div class="cents">
                        ${this._showCent(this.price)}
                      </div></span
                    >
                  </s>`:e`<span>$</span
                    ><span class="price-number flex"
                      >${this._showPrice(this.price)}
                      <div class="cents">
                        ${this._showCent(this.price)}
                      </div></span
                    >`}
            </div>
            <div class="currency"><slot name="currency"></slot></div>
            <div class="credits">${this._returnCredits()}</div>
            <div class="notation">
              <slot
                name="notation"
                @slotchange=${t=>l(t.target)}
              ></slot>
            </div>
          </div>
          <div class="primary-btn"><slot name="primary-btn"></slot></div>
        </div>
        <div class="lower">
          <div class="details"><slot name="details"></slot></div>
          <div class="secondary-btn">
            <slot
              name="secondary-btn"
              @slotchange=${t=>l(t.target)}
            ></slot>
          </div>
        </div>
      </div>
      <div class="footer"><slot name="footer"></slot></div>
    </div>`}_returnCredits(){const t=this.discounted&&this.discounted!=="0"?e`<span class="discounted-clc">${this.credits}</span>`:this.credits;return this.credits?e`or ${t} Cisco Learning Credits (CLCs)`:h}_returnHeading(){const t=e`<slot name="heading">Purchase Card</slot>`;switch(this.headingType){case"h1":return e`<h1 class="heading">${t}</h1>`;case"h2":return e`<h2 class="heading">${t}</h2>`;case"h4":return e`<h4 class="heading">${t}</h4>`;case"h5":return e`<h5 class="heading">${t}</h5>`;default:return e`<h3 class="heading">${t}</h3>`}}_showCent(t=""){const i=t.indexOf(".");return i===-1?"":parseFloat(t).toFixed(2).toString().slice(i+1)}_showPrice(t=""){return t.indexOf(".")===-1?t:t==null?void 0:t.split(".")[0]}}a([c({type:String,reflect:!0})],PurchaseCard.prototype,"price",2),a([c({type:String,reflect:!0})],PurchaseCard.prototype,"cent",2),a([c({type:String,reflect:!0})],PurchaseCard.prototype,"discounted",2),a([c({type:String,reflect:!0})],PurchaseCard.prototype,"credits",2),a([c({type:String,reflect:!0})],PurchaseCard.prototype,"headingType",2);
//# sourceMappingURL=PurchaseCard.js.map
